import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FileTextIcon, TimerIcon, ListChecksIcon, PillIcon, BoxIcon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: FileTextIcon,
    title: 'La Guía Maestra PDF "Protocolo Adiós Insomnio"',
    description: 'paso a paso.'
  }, {
    icon: TimerIcon,
    title: 'El Método de 5 Minutos de Enfriamiento',
    description: 'antes de tocar la sábana.'
  }, {
    icon: ListChecksIcon,
    title: 'El Checklist de la "Cueva de Sueño"',
    description: 'para eliminar los disparadores de calor en tu habitación.'
  }, {
    icon: BoxIcon,
    title: 'Protocolo de Rescate',
    description: 'Qué hacer exactamente cuando abres los ojos a las 3 AM para volver a dormir en menos de 10 minutos.'
  }, {
    icon: PillIcon,
    title: 'Guía de Suplementación Estratégica',
    description: 'específica para el equilibrio hormonal femenino.'
  }];
  return <section ref={ref} className="w-full bg-[#faf5eb] py-20 md:py-32" data-id="element-172">
      <div className="max-w-6xl mx-auto px-6" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-174">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#0f172a] text-center" data-id="element-175">
            Qué Obtienes Hoy
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
            {items.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 30
            }} transition={{
              delay: index * 0.1,
              duration: 0.6
            }} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow" data-id="element-177">
                  <div className="flex flex-col items-start gap-4" data-id="element-178">
                    <div className="w-12 h-12 bg-[#d4a853] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-179">
                      <Icon className="w-6 h-6 text-[#d4a853]" data-id="element-180" />
                    </div>
                    <div className="space-y-2" data-id="element-181">
                      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-182">
                        {item.title}
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-183">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="flex justify-center pt-8" data-id="element-184">
            <motion.a href="#precio" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#d4a853] text-[#0f172a] px-10 py-5 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow text-center cursor-pointer" data-id="element-185">
              ¡SÍ, QUIERO DORMIR MEJOR!
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}